import React from "react";
import { Link } from "react-router-dom";
import LegalDoc from "./LegalDoc";
import { title, lastUpdated, markdown } from "../../legal/privacy";
import { resetConsent } from "../../utils/consent";

export default function Privacy() {
    return (
        <LegalDoc
            title={title}
            lastUpdated={lastUpdated}
            markdown={markdown}
            intro={
                <p className="legal__cross">
                    See also the <Link to="/terms">Terms of Service</Link>, or{" "}
                    {/* A link, not a button, because it sits in a sentence. The
                        control has to be reachable from the policy itself:
                        "you can change your mind" is only true if there is
                        somewhere to do it. */}
                    <button
                        type="button"
                        className="legal__inline-btn"
                        onClick={resetConsent}
                    >
                        review your cookie choices
                    </button>
                    .
                </p>
            }
        />
    );
}
